import request from '@/utils/request'

// 修改手机号-验证身份验证码
const user_sms_authPhone = (data) => {
  return request({
    url: '/user/sms/authPhone',
    method: 'post',
    data
  })
}

// 修改手机号码验证码
const user_sms_modifyPhone = (data) => {
  return request({
    url: '/user/sms/modifyPhone',
    method: 'post',
    data
  })
}

// 快捷登录验证码
const user_sms_quickLogin = (data) => {
  return request({
    url: '/user/sms/quickLogin',
    method: 'post',
    data
  })
}

// 注册验证码
const user_sms_register = (data) => {
  return request({
    url: '/user/sms/register',
    method: 'post',
    data
  })
}

// 找回密码验证码
const user_sms_retrievePwd = (data) => {
  return request({
    url: '/user/sms/retrievePwd',
    method: 'post',
    data
  })
}
export {
  user_sms_authPhone,
  user_sms_modifyPhone,
  user_sms_quickLogin,
  user_sms_register,
  user_sms_retrievePwd
}
